import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const deleteScimGroup = api(async function deleteScimGroup({ id, clientId } = {}) {
    return await mutate(
        gql`
            mutation deleteScimGroup($id: String!, $clientId: String) {
                deleteScimGroup(id: $id, clientId: $clientId)
            }
        `,
        { id, clientId },
        { returns: "deleteScimGroup" }
    )
})
